import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type {
  GetDeliveryIdDetailsRequest,
  GetDeliveryIdDetailsResponse,
  GetDictionariesRequest,
  GetDictionariesResponse,
  GetMedscapeConsentDictionariesRequest,
} from './dto';
import { MedscapeAPIRoutes } from './route';

export function getDictionaries(params: GetDictionariesRequest): Promise<GetDictionariesResponse> {
  return makeRequest(
    api.get(MedscapeAPIRoutes.dictionaries(), {
      params,
    }),
  );
}

export function getDeliveryIdDetails(params: GetDeliveryIdDetailsRequest): Promise<GetDeliveryIdDetailsResponse> {
  return makeRequest(api.get(MedscapeAPIRoutes.dictionariesV7(), { params }));
}

export function getMedscapeConsentDictionaries(
  params: GetMedscapeConsentDictionariesRequest,
): Promise<GetDictionariesResponse> {
  return makeRequest(api.get(MedscapeAPIRoutes.dictionariesV7(), { params }));
}
